module.exports = __webpack_public_path__ + "img/email.5c9e0a32.png";